// import { useEffect, useRef } from "react";
// import { gsap } from "gsap";
// import { useIsMobile } from "@/hooks/use-mobile";

// export default function LogoLoader() {
//   const pathRef = useRef<SVGPathElement | null>(null);
//   const isMobile = useIsMobile();

//   useEffect(() => {
//     const pathLength = pathRef?.current?.getTotalLength();

//     // Set initial stroke styles
//     gsap.set(pathRef.current, {
//       stroke: "#4b6cb7",
//       fill: "transparent",
//       strokeWidth: 1,
//       strokeDasharray: pathLength,
//       strokeDashoffset: pathLength,
//     });

//     // Looping draw animation
//     gsap.to(pathRef.current, {
//       strokeDashoffset: 0,
//       duration: 2,
//       ease: "power1.inOut",
//       repeat: -1,
//       yoyo: true,
//     });
//   }, []);

//   return (
//     <div
//       style={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//         background: "#fff",
//       }}
//     >
//       <svg
//         width={isMobile ? "40" : "60"}
//         height={isMobile ? "40" : "60"}
//         viewBox="0 0 36 38"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path
//           ref={pathRef}
//           d="M34.4546 11.2669C35.3125 13.3066 35.797 15.3961 35.9451 17.5762C36.166 20.8267 35.7362 23.9697 34.36 26.9346C31.8229 32.4009 27.6942 35.9937 21.6749 37.3059C20.6783 37.5232 19.6737 37.6767 18.6652 37.8188C18.3005 37.8702 18.0767 37.772 17.8643 37.4436C16.1364 34.7715 14.3851 32.1142 12.6392 29.4535C12.5691 29.3468 12.4825 29.2507 12.4101 29.1581C12.1948 29.1807 12.1402 29.3401 12.0577 29.4658C10.2542 32.2129 8.45063 34.96 6.65196 37.7101C6.52881 37.8984 6.40494 38.0012 6.1542 37.9995C4.27084 37.9865 2.38724 37.9808 0.503995 37.9999C0.101888 38.004 -0.000465443 37.8801 1.58872e-06 37.4921C0.01076 28.5916 0.0111336 19.691 0.00227445 10.7904C0.0018961 10.409 0.0944247 10.27 0.503774 10.274C2.41319 10.2928 4.32291 10.2804 6.23251 10.2803C6.76343 10.2802 6.77806 10.2938 6.77828 10.8281C6.7804 15.9974 6.78126 21.1668 6.784 26.3361C6.78408 26.4858 6.74954 26.6421 6.84869 26.8092C7.09795 26.5922 7.23059 26.3066 7.40021 26.0536C8.20318 24.8559 9.00206 23.6554 9.78381 22.4441C9.96179 22.1683 10.1672 22.0745 10.4896 22.0785C11.732 22.0941 12.9748 22.0945 14.2171 22.0773C14.5417 22.0728 14.7399 22.1737 14.9191 22.4458C16.7623 25.2449 18.6173 28.0364 20.4712 30.8286C20.8757 31.4378 20.8769 31.4281 21.5688 31.151C24.8829 29.8242 27.0089 27.345 28.1527 24.0973C29.6947 19.7187 29.379 15.4273 26.9341 11.3963C25.2086 8.55138 22.635 6.87013 19.373 6.17883C17.8187 5.84942 16.2526 5.71214 14.6638 5.71756C9.96832 5.73358 5.27275 5.72503 0.577215 5.72565C0.0101013 5.72572 0.00940913 5.72448 0.00927266 5.1718C0.00888701 3.60416 0.017866 2.03643 0.00237504 0.468941C-0.00108811 0.118462 0.100949 -0.000797842 0.466561 4.01237e-06C5.68526 0.0114814 10.9042 -0.0165026 16.1226 0.0217228C18.9902 0.0427299 21.7916 0.519885 24.4902 1.52155C27.9303 2.79845 30.5795 5.04341 32.6401 8.01678C33.3453 9.03429 33.9508 10.1056 34.4546 11.2669Z"
//         />
//       </svg>
//     </div>
//   );
// }

import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { useIsMobile } from "@/hooks/use-mobile";

export default function AultaLogoLoader() {
  const logoIconRef = useRef<SVGPathElement | null>(null);
  const textPathRefs = useRef<(SVGPathElement | null)[]>([]);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const isMobile = useIsMobile();

  useEffect(() => {
    const tl = gsap.timeline({ repeat: -1, repeatDelay: 0.5 });

    // Animate the logo icon (the 'A' with gradient)
    if (logoIconRef.current) {
      const pathLength = logoIconRef.current.getTotalLength();

      gsap.set(logoIconRef.current, {
        strokeDasharray: pathLength,
        strokeDashoffset: pathLength,
        stroke: "url(#paint0_linear_12_88941)",
        strokeWidth: 2,
        fill: "transparent",
      });

      tl.to(logoIconRef.current, {
        strokeDashoffset: 0,
        duration: 1.5,
        ease: "power2.inOut",
      }).to(
        logoIconRef.current,
        {
          fill: "url(#paint0_linear_12_88941)",
          stroke: "transparent",
          duration: 0.5,
          ease: "power1.inOut",
        },
        "-=0.3",
      );
    }

    // Animate each letter of "aulta" text
    textPathRefs.current.forEach((path, index) => {
      if (path) {
        const pathLength = path.getTotalLength();

        gsap.set(path, {
          strokeDasharray: pathLength,
          strokeDashoffset: pathLength,
          stroke: "#5C3679",
          strokeWidth: 1.5,
          fill: "transparent",
        });

        tl.to(
          path,
          {
            strokeDashoffset: 0,
            duration: 0.4,
            ease: "power2.inOut",
          },
          `-=${0.2 - index * 0.1}`,
        ).to(
          path,
          {
            fill: "#5C3679",
            stroke: "transparent",
            duration: 0.3,
            ease: "power1.inOut",
          },
          `-=0.2`,
        );
      }
    });

    // Add a subtle pulse effect at the end
    tl.to(
      containerRef.current,
      {
        scale: 1.05,
        duration: 0.3,
        ease: "power1.inOut",
        yoyo: true,
        repeat: 1,
      },
      "-=0.5",
    );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div>
      <div
        ref={containerRef}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={isMobile ? "105" : "141"}
          height={isMobile ? "24" : "32"}
          viewBox="0 0 141 32"
          fill="none"
        >
          {/* Logo Icon */}
          <path
            ref={logoIconRef}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.2594 3.31593L0 0.165796H9.73938L15.6586 10.8597C16.834 6.46606 23.4249 7.84217 23.9286 10.8597L29.2181 0.165796H39.6292L23.089 30.8381C22.3334 32.6619 17.5477 32.0816 16.4982 30.8381L1.2594 3.31593ZM25.6498 22.9214V13.6782H22.5013C23.9286 8.95301 16.0364 7.21214 17.2118 13.6782H13.8954V22.9214H25.6498ZM19.017 18.6521V20.3515C19.1849 20.9732 20.7969 20.7494 20.6962 20.3515V18.6521L21.116 18.0718C20.99 15.7921 18.5972 16.0823 18.5972 18.0718L19.017 18.6521Z"
          />

          <defs>
            <linearGradient
              id="paint0_linear_12_88941"
              x1="19.8146"
              y1="0.165796"
              x2="19.8146"
              y2="31.9985"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#5F3277" />
              <stop offset="0.5" stopColor="#556684" />
              <stop offset="1" stopColor="#49A093" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
}
